// extracted by mini-css-extract-plugin
module.exports = {"link":"c8MhzNW","b2c":"CCUl9p","b2b":"S-VclT","title":"qowQM_","description":"c_2gnE7"};